import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { Return as Dialog } from '../../@types/native-api/generated/authv1';

type Config = {
  id: string;
  cardReaderName: string;
  cardReaderAddress: string;
  cardPin: string;
  vpnr: string;
  ordinationId: string;
  ordinationName: string;
  taetigkeitsBereichId: string;
  taetigkeitsBereichName: string;
};

export interface EcardState {
  dialog: Dialog | null;
  berechtigungen: string[];
  config: Config | null;
  closeDialogRequested: boolean;
  requestCloseDialog: () => void;
  setState: (dialog: Dialog, config: Config, berechtigungen: string[]) => void;
  clearState: () => void;
}

export const useEcardStore = create<EcardState>()(
  devtools(
    set => ({
      dialog: null,
      config: null,
      berechtigungen: [],
      closeDialogRequested: false,
      requestCloseDialog: () => set({ closeDialogRequested: true }),
      setState: (dialog, config, berechtigungen) => set({ dialog, config, berechtigungen }),
      clearState: () => set({ dialog: null, config: null, berechtigungen: [], closeDialogRequested: false }),
    }),
    { name: 'ecard-store' }
  )
);
